import { BigNumber } from '../types.js';
export class PrimitiveValidator {
    constructor(schema) {
        this.schema = schema;
    }
    validString(v) {
        return typeof v === 'string';
    }
    validMlString(v) {
        return this.validString(v) ||
            Object.entries(v).every(([lang, value]) => this.schema.languages.includes(lang) && this.validString(value));
    }
    validNumber(value) {
        return typeof value === 'number';
    }
    validBigNumber(value) {
        try {
            new BigNumber(value);
        }
        catch (e) {
            return false;
        }
        return true;
    }
    validBoolean(value) {
        return typeof value === 'boolean';
    }
}
//# sourceMappingURL=PrimitiveValidator.js.map